import React, { useEffect, useState } from "react";

export function ScrollTop() {
  const [isVisible, setIsVisible] = useState(false);

  // Show button after scrolling down 200px
  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 200);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // smooth scroll animation
    });
  };

  return (
    isVisible && (
      <div
        onClick={scrollToTop}
        className="scrolltop-btn bg-secondary text-white p-2 rounded-circle position-fixed"
        style={{
          bottom: "20px",
          right: "20px",
          cursor: "pointer",
          zIndex: 1000,
        }}>
        <span
          style={{ height: "20px", width: "20px" }}
          className="d-flex align-items-center justify-content-center">
          <i className="fa fa-arrow-up"></i>
        </span>
      </div>
    )
  );
}
